module.exports = __webpack_public_path__ + "static/img/21-红英小学(六里屯校区)1.5b7d569.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/21-红英小学(六里屯校区)1.png
// module id = Ne95
// module chunks = 0